<script setup lang="ts">
type Props = {
  src: string;
  alt: string;
};
const props = defineProps<Props>();
</script>
<template>
  <div class="lg:grid grid-cols-6">
    <div class="col-span-5 xl:col-span-4 relative order-1 xl:order-2">
      <div
        class="relative xl:border-t-[0.75rem] border-primary-300 dark:border-primary-600 shadow-md"
      >
        <NuxtImg
          class="min-w-full"
          :alt="props.alt"
          :src="props.src"
          width="800"
          height="800"
          fit="inside"
          loading="eager"
          fetchpriority="high"
        />
      </div>
    </div>
    <div class="col-span-1 xl:col-span-2 relative hidden lg:block order-3">
      <div class="absolute left-0 top-0 w-full h-full">
        <div
          class="relative top-0 left-0 h-[0.75rem] w-full z-10 bg-primary-300 dark:bg-primary-600"
        />
        <UiStripes class="h-[calc(100%-0.75rem)]" />
      </div>
    </div>
  </div>
</template>
